var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.45,
    height: 20,
    viewBox: "0 0 17.45 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.45,19a1,1,0,0,1-1,1H1a1,1,0,0,1,0-2H16.45A1,1,0,0,1,17.45,19ZM8,15.57a1,1,0,0,0,.32.22,1,1,0,0,0,.38.08,1.09,1.09,0,0,0,.39-.08,1,1,0,0,0,.32-.22l4.94-4.94A1,1,0,0,0,13,9.21L9.72,12.45V1a1,1,0,0,0-2,0V12.45L4.49,9.21a1,1,0,0,0-1.42,1.42Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4fc524a3c39cb2f5a591086981688414.svg";
export { ForwardRef as ReactComponent };